"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Contract = require("@tableau/api-external-contract-js");
const TableauEvent_1 = require("./TableauEvent");
class WorkbookFormattingChangedEvent extends TableauEvent_1.TableauEvent {
    constructor(_formatting) {
        super(Contract.TableauEventType.WorkbookFormattingChanged);
        this._formatting = _formatting;
    }
    get formatting() {
        return this._formatting;
    }
}
exports.WorkbookFormattingChangedEvent = WorkbookFormattingChangedEvent;
//# sourceMappingURL=WorkbookFormattingChangedEvent.js.map